var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","title":_vm.theme === 'dark' ? 'Thème clair' : 'Thème sombre',"aria-label":_vm.theme === 'dark' ? 'Passer en thème clair' : 'Passer en thème sombre'},on:{"click":_vm.toggle}},[_c('v-icon',[_vm._v(_vm._s(_vm.theme === 'dark' ? 'light_mode' : 'dark_mode'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }